import React from 'react';
import { ExternalLink } from './Links';
import { faTwitter, faPinterest, faLinkedinIn, faInstagram } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const SocialLink = ({ href, icon, ...rest }) => <ExternalLink href={href} target='_blank' {...rest}><FontAwesomeIcon
  icon={icon}/></ExternalLink>;

export const FooterDefault = ({ className }) => {
  const links = [
    { href: 'https://twitter.com/ApostropheLLC', icon: faTwitter },
    { href: 'https://www.pinterest.com/MadeByApostrophe/', icon: faPinterest },
    { href: 'https://www.linkedin.com/company/apostrophe-llc/', icon: faLinkedinIn },
    { href: 'https://www.instagram.com/made_by_apostrophe/', icon: faInstagram}
  ];

  return (
    <footer className={`text-center text-grey-darker text-xs mb-xs py-8 md:py-16 z-10 ${className}`}>
      <ul className="list-reset flex w-full justify-center mb-4">
        {links.map((link, i) => <li key={i} className='mx-3 text-2xl'>
          <SocialLink {...link} className='text-light hover:text-grey'/>
        </li>)}
      </ul>
      <div className="text-light text-lg tracking-x-wide">copyright | apostrophe llc | 2018</div>
    </footer>
  );
};



// WEBPACK FOOTER //
// ./src/components/Footer.js